// eslint-disable-next-line import/prefer-default-export
export function findEmployeeCategoryName(categories, id) {
  const category = (categories || []).find((cat) => cat.id === id);

  return category ? category.name : null;
}
